export class PqrUserProjectEntity{
    
    id:number;
    userId:number;
    projectId:number;

    constructor () {}
}